// extracted by mini-css-extract-plugin
module.exports = {"label":"LanguageToggler_label_2zcMQ","blackLabel":"LanguageToggler_blackLabel_2zB8d","switch":"LanguageToggler_switch_3KzOM"};